export const ComparePerformanceMock = {
    mutualFunds: [
        {
            ticker: 'PRXCX',
            iClass: false,
            name: 'California Tax-Free Bond Fund',
            inceptionDate: '1986-09-15T04:00:00Z',
            moneyMarket: false,
            tackedReturnFundInceptionDate: null,
            morningStarOverallRating: 4,
            morningStarOverallQuantity: 103,
            morningStarAsOfDate: '2023-02-28T05:00:00Z',
            morningStarCategoryName: 'Muni California Long',
            sevenDayYieldSimple: null,
            sevenDayYieldSimpleAsOfDate: '2020-05-31T04:00:00Z',
            unsubsidizedSevenDayYieldSimple: null,
            yield30DayStandard: 3.32,
            yield30DayStandardEffectiveDate: '2023-02-28T05:00:00Z',
            unsubsidizedThirtyDaySECYield: 3.32,
            ytdMonthlyTotalReturns: 0.76,
            ytdMonthlyAsOfDate: '2023-02-28T05:00:00Z',
            standardPerformanceReturns: {
                threeMonthReturn: {
                    asOfDate: '2023-02-28T05:00:00Z',
                    fundReturn: 0.66,
                    __typename: 'FundReturn'
                },
                monthlyAnnualReturns: {
                    fundPerformance: {
                        asOfDate: '2023-02-28T05:00:00Z',
                        oneYearReturn: -5.71,
                        threeYearReturn: -1.64,
                        fiveYearReturn: 1.44,
                        tenYearReturn: 2.21,
                        sinceInceptionReturn: 4.86,
                        threeYearReturnTacked: false,
                        __typename: 'YearlyReturns'
                    }
                },
                quarterlyAnnualReturns: {
                    fundPerformance: {
                        asOfDate: null, // '2022-12-31T05:00:00Z',
                        oneYearReturn: null, // -9.29,
                        threeYearReturn: null, // -0.93,
                        fiveYearReturn: null, // 1,
                        tenYearReturn: null, // 2.25,
                        sinceInceptionReturn: null, // 4.86,
                        __typename: 'YearlyReturns'
                    }
                }
            },
            __typename: 'GraphQLMutualFund'
        }
    ]
};
